import { defineMessages } from 'react-intl'

export default defineMessages({
  modalTitle: {
    id: 'containers.ProjectPage.components.DownloadModal.title',
    defaultMessage: 'Download demos',
  },
  modalBodyGate: {
    id: 'containers.ProjectPage.components.DownloadModal.body.gate',
    defaultMessage:
      'To download the sample for sharing and demo purposes, please submit your e-mail address below. By downloading you are agreeing to our {terms}.',
  },
  modalBody: {
    id: 'containers.ProjectPage.components.DownloadModal.body',
    defaultMessage: 'Thanks! Please close this to download any demos from your selection, by clicking the {icon} icon next to the demo you would like to download.',
  },
  download: {
    id: 'containers.ProjectPage.components.DownloadModal.download',
    defaultMessage: 'Close & Download',
  },
  submit: {
    id: 'containers.ProjectPage.components.DownloadModal.submit',
    defaultMessage: 'Submit e-mail',
  },
  close: {
    id: 'containers.ProjectPage.components.DownloadModal.close',
    defaultMessage: 'Close',
  },
  terms: {
    id: 'containers.ProjectPage.components.DownloadModal.terms',
    defaultMessage: 'terms and conditions',
  },
  termsHref: {
    id: 'containers.ProjectPage.components.DownloadModal.terms.href',
    defaultMessage: 'https://www.voicearchive.com/terms-conditions/',
  },
  subscribeToNewsletter: {
    id: 'containers.ProjectPage.components.DownloadModal.subscribeToNewsletter',
    defaultMessage: 'Yes - send me artist recommendations and tips',
  },
})
